import type { RefObject } from "react";

export interface QuoteComposerHandle {
  insertQuote: (quote: string) => void;
  focus: () => void;
}

export interface QuotePayload {
  roomId: string;
  sender: string;
  ts?: number;
  eventId: string;
  body: string;
}

export function quoteEventUrl(roomId: string, eventId: string): string {
  return `https://matrix.to/#/${roomId}/${eventId}`;
}

export function formatQuote(payload: QuotePayload): string {
  const quotedBody = payload.body
    .split("\n")
    .map((line) => `> ${line}`)
    .join("\n");
  return `${quotedBody}\n> — ${payload.sender}, [link to event](${quoteEventUrl(
    payload.roomId,
    payload.eventId,
  )})`;
}

export function insertQuote(
  composerRef: RefObject<QuoteComposerHandle | null> | undefined,
  payload: QuotePayload,
): void {
  composerRef?.current?.insertQuote(formatQuote(payload));
}
